module.exports = __webpack_public_path__ + "static/media/ic_list_black_36px.715e6b8e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ic_list_black_36px.svg
// module id = 795
// module chunks = 0